export const basename = () => '';
export default {};
